import * as React from "react"
const SvgPercent = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M15 16.786q.625 0 1.063-.438.437-.437.437-1.062t-.438-1.063A1.45 1.45 0 0 0 15 13.786q-.624 0-1.063.437a1.45 1.45 0 0 0-.437 1.063q0 .624.438 1.062.437.438 1.062.438m-7.25-.25a.95.95 0 0 0 .7.275.95.95 0 0 0 .7-.275l7.1-7.1a.95.95 0 0 0 .275-.7.95.95 0 0 0-.275-.7.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275l-7.1 7.1a.95.95 0 0 0-.275.7q0 .424.275.7M9 10.786q.624 0 1.063-.438.437-.437.437-1.062t-.438-1.063A1.45 1.45 0 0 0 9 7.786q-.624 0-1.063.437A1.45 1.45 0 0 0 7.5 9.286q0 .624.437 1.062.438.438 1.063.438" />
    <path
      fillRule="evenodd"
      d="M5 21.286q-.824 0-1.413-.588A1.93 1.93 0 0 1 3 19.286v-14q0-.825.587-1.413A1.93 1.93 0 0 1 5 3.286h14q.824 0 1.413.587.587.588.587 1.413v14q0 .825-.587 1.412a1.93 1.93 0 0 1-1.413.588zM5 5.289v13.993l.002.002.001.002h13.994l.001-.002.002-.002V5.29l-.002-.002-.002-.001H5.004l-.001.001L5 5.29Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgPercent
